import { CompetitorCopy } from "./_copy-template"

import ChckvetVsAllyDVM from "~images/pages/comparison/allydvm/chckup-vs-allydvm.png"
import MobileChckvetVsAllyDVM from "~images/pages/comparison/allydvm/mobile-chckup-vs-allydvm.png"

import { getAnalyticsCopy } from "./feature-copy/analytics"
import { getSchedulingCopy } from "./feature-copy/scheduling"
import { getClientCommunicationCopy } from "./feature-copy/client-communication"
import { getLoyaltyCopy } from "./feature-copy/loyalty"
import { getReviewsCopy } from "./feature-copy/reviews"
import { getEnterpriseCopy } from "./feature-copy/enterprise"
import { getUserExperienceCopy } from "./feature-copy/user-experience"

const AllyDVM: CompetitorCopy = {
    company: "AllyDVM",
    landing: {
        gradientString: "linear(to-br, #02B4E6, #3C289B)",
        subtitle:
            "Chckvet is the AllyDVM alternative that makes real-time online scheduling and client interaction quick and easy for both veterinary practices and pet owners.",
        tagline: "What makes Chckvet a great AllyDVM alternative?",
        paragraph: [
            "Chckvet is a robust AllyDVM alternative that goes above and beyond to provide online scheduling, client communication, reputation management, and in-depth analytics for veterinary practices.",
            "We strive to bring the best veterinary business tools to our clients, and we're constantly listening to feedback from all of our users. New features are released weekly, you can get support directly from the founders, and it goes above and beyond what has become the industry standard.",
        ],
        mobileImage: MobileChckvetVsAllyDVM,
        desktopImage: ChckvetVsAllyDVM,
    },
    features: [
        getAnalyticsCopy({
            hidden: true,
            showCheck: false,
            description:
                "With AllyDVM, you are limited in the number of metrics you can track.",
        }),
        getSchedulingCopy({
            hidden: true,
            showCheck: false,
            description:
                "With AllyDVM, your patients and front desk staff have to go back-and-forth just to make an appointment.",
        }),
        getClientCommunicationCopy({
            hidden: true,
            showCheck: true,
            description:
                "With AllyDVM, you can send automated emails, texts, and push notifications to your patients to remind them of their appointments.",
        }),
        getLoyaltyCopy({
            hidden: true,
            showCheck: true,
            description:
                "With AllyDVM, you can create & support a customized loyalty reward program just for clients of your practice.",
        }),
        getReviewsCopy({
            hidden: true,
            showCheck: false,
            description:
                "With AllyDVM, you have limited review/feedback functionality.",
        }),
        getEnterpriseCopy({
            hidden: true,
            showCheck: false,
            description:
                "With AllyDVM, you have limited enterprise functionality.",
        }),
        getUserExperienceCopy("AllyDVM", true),
    ],
}

export default AllyDVM
